export default __webpack_public_path__ + "2647c426386b3af38dc00375cfb60065.svg";